import themes from "devextreme/ui/themes";
import 'react-block-ui/style.css';
import 'react-dual-listbox/lib/react-dual-listbox.css';
import '../css/App.css';
import '../css/omnichannel.css';
import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import esMessages from "devextreme/localization/messages/es.json";
import { locale, loadMessages } from "devextreme/localization";

import store from '../redux/store';
import Login from './user/login';
import CheckToken from '../middleware/checkToken';
import Main from './main';
import Widgets from './widgets';
import Groups from "./groups/groups";
import Agents from "./agents/agents";
import Dashboard from './dashboard';
import { useTranslation } from 'react-i18next';
  
function App() {

  const { i18n } = useTranslation();
  if (i18n.dir() === "rtl")
    document.dir = i18n.dir();

  useEffect(() => {
    let theme = localStorage.getItem("faTheme");
    themes.current(`generic.${theme}.compact`);
    loadMessages(esMessages);
    locale(navigator.language);
    return () => {
    }

  }, []);


  return (
    <Provider store={store}>
      <Routes>
        <Route path="login" element={<Login />} />
        <Route path="main" element={<CheckToken><Main /></CheckToken>}>
          <Route path="widgets" element={<Widgets />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="agents" element={<Agents />} />
          <Route path="groups" element={<Groups />} />
        </Route>
        <Route path="/" element={<CheckToken />} />
      </Routes>
    </Provider>
  );
}


export default App;
